import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import api from '../api';
import Nav from '../components/Nav';
import Chat from '../components/Chat';

function Days() {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/public/days')
      .then(({ data }) => setEntries(data.entries))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <Nav active="days" />
      <div className="page">
        <div className="section-header">
          <h1 className="section-title">My Days</h1>
          <span className="section-subtitle">{entries.length} entries</span>
        </div>

        {loading ? (
          <div className="loading">loading...</div>
        ) : entries.length === 0 ? (
          <div className="empty">
            <h2>No days written yet</h2>
            <p>The timeline is waiting to be filled.</p>
          </div>
        ) : (
          <div className="timeline">
            {entries.map((entry) => {
              const dateStr = entry.entry_date.split('T')[0];
              return (
              <div
                key={dateStr}
                className="day-card"
                onClick={() => navigate(`/days/${dateStr}`)}
              >
                <div className="day-date">
                  {format(new Date(dateStr + 'T00:00:00'), 'EEEE, MMMM d, yyyy')}
                </div>
                <div className="day-content">{entry.content}</div>
                <div className="day-meta">
                  {entry.mood && <span className="badge badge-mood">{entry.mood}</span>}
                  {entry.weather && <span className="badge badge-weather">{entry.weather}</span>}
                  {entry.song && <span className="badge badge-tag">{entry.song}</span>}
                </div>
              </div>
              );
            })}
          </div>
        )}
      </div>
      <Chat />
    </div>
  );
}

export default Days;
